import { useState, useEffect } from 'react';
import { postMessageToParent } from '../message-bus/postMessageToParent';

export interface ExtensionInitTimingData {
	scriptInitDuration: number;
	pageReadyDuration: number;
	scriptInitStartTime: number;
	pageReadyEndTime: number;
	// Iframe load timing data (only present when iframe load is complete)
	iframeLoadDuration?: number;
	iframeLoadStartTime?: number;
	iframeLoadEndTime?: number;
	error?: boolean;
}

export const useExtensionInitTiming = (): ExtensionInitTimingData | undefined => {
	const [timingData, setTimingData] = useState<ExtensionInitTimingData | undefined>();

	useEffect(() => {
		const messageHandler = (event: MessageEvent): void => {
			if (event.data.type === 'GET_EXTENSION_INIT_TIMING_RESPONSE') {
				setTimingData(event.data.timingData);
			} else if (event.data.type === 'IFRAME_LOAD_COMPLETE') {
				// Request updated timing data immediately when iframe load completes
				postMessageToParent({ type: 'GET_EXTENSION_INIT_TIMING_REQUEST' });
			}
		};

		window.addEventListener('message', messageHandler, false);

		// Request timing data from extension-chrome
		postMessageToParent({ type: 'GET_EXTENSION_INIT_TIMING_REQUEST' });

		return (): void => {
			window.removeEventListener('message', messageHandler);
		};
	}, []); // No dependencies - effect runs once on mount

	return timingData;
};
